<template>
    <div style="height: 90vh; overflow: auto; background-color: #FAFAFA;">
      <div class="container">
        <div class="product-name">
          <span class="zh-name">蛋白组学</span>
          <span class="en-name">Proteomics</span>
          <span class="sub-name">强大生信团队/软硬件先进/质控严格/交付周期短</span>
        </div>
        <div class="slogan" v-if="showPromotion">{{promotion.description}}</div>
        <div class="service-wrapper">
          <div v-for="(item, index) in serviceItems" :key="index">
            <span class="service-icon">
              <img :src="item.serviceSvgUrl" :data-src="item.serviceSvgUrl"/>
            </span>
            <span class="service-txt" v-text="item.serviceTxt"></span>
            <span class="service-sub-txt" v-text="item.serviceSubTxt"></span>
          </div>
        </div>
        <div class="btn-group">
          <van-row>
            <van-col :span="24 / categoryList.length" v-for="(item, index) in categoryList" :key="index">
              <van-button round size="small" block :plain="plain[index]" @click="onChange(index, item)" color="#5878FA">{{item.dictValue}}</van-button>
            </van-col>
          </van-row>
        </div>
        <div>
          <qualitative-tech v-if="plain[0]" :dataList="productList" ref="qualitativeTech"  @callback="handleProduct"></qualitative-tech>
          <quantitative-tech v-if="plain[1]" :dataList="productList" @callback="handleProduct" ref="send"></quantitative-tech>
          <modification-tech v-if="plain[2]" :dataList="productList" @callback="handleProduct"></modification-tech>
        </div>
        <div>
          <proteomics-desc></proteomics-desc>
        </div>
      </div>
       <div class="shopping-footer">
            <van-button
                class="bottom-button-large"
              color="#5878FA"
              type="danger"
              text="下一步"
             @click="onClickNextStep"
            />
       </div>
      <!--      我是有底线的，无需修改什么。-->
      <div style="color: #D2D2D6; text-align: center;pointer-events:none;">
        <p style="font-size: 12px; margin-bottom: 50%;">---我是有底线的---</p>
      </div>
    </div>
</template>
<script>
/* eslint-disable */
  import QualitativeTech from './components/QualitativeTeach.vue'
  import QuantitativeTech from './components/QuantitativeTech.vue'
  import ModificationTech from './components/ModificationTech.vue'
  import ProteomicsDesc from './components/ProteomicsDesc.vue'
  import emkt from '@/emkt.js'
  import { Toast } from 'vant'
import {deDuplication, filterMeteData,} from '../../util/templateToUserData'
  export default {
    components: {
      QualitativeTech,
      QuantitativeTech,
      ModificationTech,
      ProteomicsDesc
    },
    data () {;
      return {
        plain: [false, true, false],
        filterProduct: {},
        isQualitativeTech: false,
        isQuantitativeTech: true,
        isModificationTech: false,
        showPromotion: false,
        promotion: {},
        categoryList: [],
        serviceItems: [
          {
            serviceTxt: '强大生信团队',
            serviceSubTxt: '个性化一对一',
            serviceSvgUrl: '/static/img/svg/强大生信团队.svg'
          },
          {
            serviceTxt: '软硬件先进',
            serviceSubTxt: '设备一流',
            serviceSvgUrl: '/static/img/svg/软硬件先进.svg'
          },
          {
            serviceTxt: '质控严格',
            serviceSubTxt: '明确质控结果',
            serviceSvgUrl: '/static/img/svg/质控严格.svg'
          },
          {
            serviceTxt: '交付周期短',
            serviceSubTxt: '最短30个工作日',
            serviceSvgUrl: '/static/img/svg/交付周期短.svg'
          }
        ],
        productList: [],
        proteomicsSkus: [],
        targetSku: Object.assign({})
      }
    },
    created () {
      localStorage.removeItem('sample')
      this.$weui.loading('正在加载~')
      this.fetchData()
    },
    methods: {
      fetchProductPromotions (data) {
        this.showPromotion = false
        this.gcapi('getServiceProductPromotions', data).then(res => {
          if (res.data.code === 0) {
            if (res.data.result.length > 0) {
              this.showPromotion = true
              this.promotion = res.data.result[0]
            }
          }
        })
      },
      fetchData () {
        this.gcapi('getProteomicsBasicData', '').then(res => {
          if (res.data.code === 0) {
            this.proteomicsSkus = res.data.result.proteomicsSku.sort(function (a, b) {
              return  a.sortOrder - b.sortOrder
            })
            console.log(this.proteomicsSkus)
            this.categoryList = filterMeteData(undefined, deDuplication(this.proteomicsSkus, 'techCategory'), 71001)
            let filterSkus = {}
            let filterProduct = {}
            //得到技术分类,并依据技术分类将sku分类
            deDuplication(this.proteomicsSkus, 'techCategory').forEach(item=> {
              filterSkus[item] = filterMeteData(this.proteomicsSkus, item, undefined, 'techCategory')
            })
            for (let key in filterSkus) {
              filterProduct[key] = deDuplication(filterSkus[key],'productCategory')
            }
            for (let key in filterProduct) {
              this.filterProduct[key] = filterMeteData(undefined, filterProduct[key], 71002)
            }
            this.onChange(1, 2)
            this.$weui.loading().hide()
          }
        })
      },
      setProductList (techCategory) {
        if (techCategory.dictKey) {
          this.productList = Object.assign({},this.filterProduct[techCategory.dictKey])
          this.$nextTick(() => {
            this.handleProduct(this.productList[0])
          })
        } else {
          this.productList = Object.assign({},this.filterProduct[techCategory])
        }
        this.$nextTick(() => {
          this.handleProduct(this.productList[0])
          new Promise(resolve => {
            if (this.plain[1]) {
              this.$refs.send.handleSearchRecommend()
            }
            Toast.loading();
            setTimeout(() => {
              Toast.clear();
              resolve(this.validateFlag)
            }, 200)
          }).then(go => {
            if (this.plain[1]) {
              this.$refs.send.handleSearchRecommend()
            }
          })
        })
      },
      onChange (index, dictKey) {
        console.log(index, dictKey)
        this.plain.forEach((item, i) => {
          this.plain[i] = (i === index)
        })
        this.$forceUpdate()
        this.setProductList(dictKey)
      },
      onClickNextStep () {
        console.log(this.targetSku, 'sssssssssssssssssssssssssssss')
        if (this.targetSku) {
          if (this.targetSku.eu1) {
            localStorage.setItem('product', JSON.stringify(this.targetSku))
            localStorage.setItem('promotion', JSON.stringify(this.promotion))
            console.log(this.targetSku)
            if (this.plain[1]) {
              this.$refs.send.sendInfo()
            }
            this.$router.push({
              name: 'boSolution',
              query: {'templateNo': this.targetSku.eu1, 'product': this.targetSku.productName}})
          } else {
            Toast('请选择产品')
          }
        } else {
          Toast('请选择产品')
        }
      },
      handleProduct (obj) {
        if (obj !== null) {
          let dictKey = obj.dictKey
          let targetSkus = this.proteomicsSkus.filter(v => v.productCategory === dictKey)
          if (targetSkus.length > 0) {
            this.targetSku = targetSkus[0]
            this.targetSku.productName = obj.dictValue
            this.targetSku.productDesc = obj.extraValue
            console.log(this.targetSku)
            let data = this.targetSku.eu1_Pus.filter(v => v.includes('SPEC') === false)
            this.fetchProductPromotions(data)
          }
        } else {
         this.targetSku = obj
        }
      }
    }
  }
</script>

<style scoped>
    .container {
        background: #fafafa;
        min-height: 100vh;
        padding: 20px 10px;
    }
    .product-name {
        padding: 0 10px 13px;
    }
    .zh-name {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #424242;
        line-height: 28px;
    }
    .en-name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
        line-height: 20px;
    }
    .sub-name {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5878FA;
        line-height: 17px;
        display: block;
    }
    .slogan {
        border-radius: 44px;
        border: 1px solid #FE654D;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FE654D;
        line-height: 17px;
        padding: 3px 10px;
        margin-left: 10px;
        width:auto;
        display:inline-block;
    }
    .service-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0 10px;
    }
    .service-wrapper span {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: block;
        text-align: center;
    }
    .service-txt {
        font-size: 12px;

        color: #424242;
        line-height: 17px;

    }
    .service-sub-txt {
        font-size: 10px;
        color: #979797;
        line-height: 14px;
    }
    .btn-group {
        background: #5878FA;
        border-radius: 44px;
        padding: 1px;
    }
    .shopping-footer {
      position: fixed;
      top: 90vh;
      width: 100%;
      height: 10vh;
      background: white;
      padding:10px;
    }
    .bottom-button-large{
      margin-top: 15px;
      width: 100%;
      border-radius: 44px;
      border: 1px solid #5878fa;
      font-size: 14px;
      height: 35px;
    }
</style>



// WEBPACK FOOTER //
// Purchase.vue?3adb7730